(function () {
  'use strict';

  angular.module('sempraWebapp').service('schemaUtils', schemaUtilsService);

  /** @ngInject */
  function schemaUtilsService () {
    this.COLORS = Object.freeze({
      working: 'green',
      notWorking: 'gray',
      error: 'red',
      highFloatWorking : 'gray',
      highFloatNotWorking : 'green'
    });
  }
})();
